import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

type R = "user" | "transaction";

class KYCEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get(`manager/compliance-trackings`, params);
  }

  public collection(
    entity: R,
    id: string | number,
    get_parameters: {
      [index: string]: object | null | string | number | boolean;
    } = {}
  ): Promise<AxiosResponse> {
    const request = {} as AxiosRequestConfig;
    request.params = get_parameters;

    return $api.get(`manager/compliance-trackings/${entity}/${id}`, request);
  }

  public counts(entity: R, id: string | number): Promise<AxiosResponse> {
    return $api.get(`manager/compliance-trackings/${entity}/${id}/counts`);
  }

  public requestVideoVerificationUrl(
    id: string | number
  ): Promise<AxiosResponse> {
    return $api.get(
      `manager/compliance-trackings/${id}/video-verification-url`
    );
  }

  public requestFormVerificationUrl(
    id: string | number
  ): Promise<AxiosResponse> {
    return $api.get(`manager/compliance-trackings/${id}/form-verification-url`);
  }

  public uploadUrl(kyc_id: string | number, file_id: string | number): string {
    return `${$api.vueInstance.axios.defaults.baseURL}/manager/compliance-trackings/${kyc_id}/files/${file_id}/document`;
  }

  public getDocumentForSignature(
    kyc_id: string | number,
    file_id: string | number
  ): Promise<AxiosResponse> {
    return $api.post(
      `manager/compliance-trackings/${kyc_id}/files/${file_id}/signature`
    );
  }
}

export default KYCEndpoint;
